import { lazy, Route } from '@tanstack/router'

import { rootRoute } from './root'

const MetaAdsLanding = lazy(() => import('../pages/meta-ads-landing'))

export const metaAdsLandingRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/meta-ads-landing',
  component: MetaAdsLanding,
})
